import React, { useEffect, useRef, useState } from "react";
import {
  TrashFill,
  Download,
  PlusCircleFill,
  PeopleFill,
  HandThumbsUp,
  ChatFill,
  EyeFill,
  FileEarmarkPdf,
} from "react-bootstrap-icons";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import PageHeader from "../../components/PageHeader/PageHeader";
import CommonTable, { TableColumn } from "../../components/Table/CommonTable";
import { postDetails, fetchMedia } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../store/storeRequests";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { Button, InputGroup, Modal, Form } from "react-bootstrap";
import ModalWrapper from "../../components/Modal/ModalWrapper";
import { ModalRef } from "../../utils/constants/Interfaces.constants";
import CustomButton from "../../components/CustomButton/CustomButton";
import formatDate from "../../utils/helpers/formatDate";
import { hideToast, showToast } from "../../store/Toast/toast.slice";
import defaultProfile from "../../assets/default-profile.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import sortByRecentDate from "../../utils/helpers/sortByRecentDate";
import "./postlisting.scss";
import InputField from "../../components/InputField/InputField";
import useDebounce from "../../hooks/useDebounce";

interface PostListing {
  id: number;
  profile_pic: string;
  userName: string;
  post_status: string;
  status?: number;
  thumb_image: any;
  media_type: any;
  media_file: any;
}

interface Payload {
  type: number;
  pageSize: number;
  pageNumber: number;
  sortBy?: string; 
};

const Post_Listing: React.FunctionComponent = () => {
  // const [data, setData] = useState<PostListing[]>([]);
  const cmpMounted = useRef(false);
  const dispatch = useAppDispatch();
  const modalRef = useRef<ModalRef>(null);
  const modalRefComment = useRef<ModalRef>(null);
  const modalRefLike = useRef<ModalRef>(null);
  const modalRefView = useRef<ModalRef>(null);
  const modalRefViewIndividual = useRef<ModalRef>(null);
  // const modalRefViewIndividual = useRef(null);
  const [likesData, setLikesData] = useState<any>([]);
  const [CommentData, setcommentData] = useState<any>([]);
  const [viewListData, setviewListData] = useState<PostListing[] | null>(null);
  const [folder, setFolders] = useState<PostListing[]>([]);
  // const [selectedMedia, setSelectedMedia] = useState<PostListing[] | null>(null);
  const [selectedMedia, setSelectedMedia] = useState<PostListing | null>(null);
  const [feedType, setFeedType] = useState<number>(0);
  const [postType, setPostType] = useState<string>("image");
  const modalRefVid = useRef<ModalRef>(null);
  const [selectedItems, setSelectedItems] = useState<Set<number>>(new Set());
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDownloadMediaModal, setShowDownloadMediaModal] = useState(false);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [dateErrors, setDateErrors] = useState({
    startDateError: "",
    endDateError: "",
  });
  const [isDownloading, setIsDownloading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const navigate = useNavigate();

  // useEffect(() => {
  //   if (cmpMounted.current === true) return;
  //   cmpMounted.current = true;
  //   fetchGetAllFolder();
  // }, []);

  const debouncedSearchQuery = useDebounce(searchQuery, 500);

  useEffect(() => {
    const fetchDataAndUpdate = async () => {
      // const data = await fetchData(searchQuery, 5, 1); 
      await fetchGetAllFolder(feedType, 1, debouncedSearchQuery); 
      // setTableData(data?.result || []);
    };
    fetchDataAndUpdate();
  }, [debouncedSearchQuery]);

  const handlePageChange = (page: number) => {
    fetchGetAllFolder(feedType, page+1, debouncedSearchQuery);
  };

  // const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   console.log(e.target.value)
  //   setSearchQuery(e.target.value);
  // };

  const handleSearch = (searchTerm: string) => {
    setSearchQuery(searchTerm); // Update search term in state
  };  

  const fetchGetAllFolder = async (type: number = feedType, page: any = 1, query:string = "") => {
    const payload: Payload = {
      type: type,
      pageSize: 10,
      pageNumber: page,
      sortBy: query.trim()
    };

    try {
      dispatch(showLoader("Loading data..."));
      const response = await postDetails(
        APIList.GETALL_CULTURAL_CLUB_DATA,
        payload
      );
      // console.log(response.data);
      const sortedFeed = sortByRecentDate(response.data.result, "display_time");
      setTotalRecords(response.data.totalcount);

      const modifiedFeed = sortedFeed.map((item: any) => ({
        ...item,
        name: item.user?.name,
        profile: item.user?.profile || defaultProfile,
        display_time: item.display_time
          ?  new Date(
            new Date(item.display_time).getTime() + new Date().getTimezoneOffset() * 60000
          ).toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
          : "",
        // user: undefined,
        reportRemarkByAdmin:
          item.reportRemarkByAdmin === null ||
          item.reportRemarkByAdmin === "null"
            ? ""
            : item.reportRemarkByAdmin,
        reportRemarkByAdminDate: item.reportRemarkByAdminDate
          ?  new Date(item.reportRemarkByAdminDate).toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
          : "",
      }));
      // setFeed(modifiedFeed);
      // console.log(modifiedFeed);
      setFolders(modifiedFeed || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(showToast("Some error occurred while fetching posts"));
      setTimeout(() => dispatch(hideToast()), 3000);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleCloseModal = () => setShowDeleteModal(false);

  const handleDownload = () => {
    // let errors = { startDateError: "", endDateError: "" };
    // const today = new Date();
    // // Validate start date (No validation needed since it can be any date)
    // if (!startDate) {
    //   errors.startDateError = "Please select a start date.";
    // }
    // // Validate end date
    // if (!endDate) {
    //   errors.endDateError = "Please select an end date.";
    // } else if (endDate < startDate!) {
    //   errors.endDateError = "End date cannot be earlier than the start date.";
    // } else if (endDate > today) {
    //   errors.endDateError = "End date cannot be later than today.";
    // }
    // setDateErrors(errors);
    // If no errors, proceed with download
    // if (!errors.startDateError && !errors.endDateError) {
    //   const formattedStartDate = startDate!.toISOString(); // UTC
    //   const formattedEndDate = endDate!.toISOString(); // UTC
    //   if (mediaType === "photos") {
    //     downloadPhotos(formattedStartDate, formattedEndDate);
    //   } else if (mediaType === "videos") {
    //     downloadVideos(formattedStartDate, formattedEndDate);
    //   }
    //   closeModal();
    // }
  };

  // const columns: TableColumn[] = [
  //   {
  //     key: "profile",
  //     label: "Profile Pic",
  //     sortable: false,
  //     dataType: "image",
  //   },
  //   { key: "name", label: "User Name", sortable: true },
  //   { key: "post_status", label: "Content", sortable: false },

  //   { key: "assets_count", label: "Media" },
  //   { key: "likes_count", label: "Likes" ,button: {
  //     label: (item) => (
  //       <div style={{ display: "flex", alignItems: "center" }}>
  //         <HandThumbsUp style={{ marginRight: "8px" }} />
  //         {item.likes_count || 0}
  //       </div>
  //     ),
  //     onClick: (item) => handleViewLike(item),
  //   },},
  //   { key: "comments_count", label: "Comment",button: {
  //     label: (item) => (
  //       <div style={{ display: "flex", alignItems: "center" }}>
  //         <ChatFill style={{ marginRight: "8px" }} />
  //         {item.comments_count || 0}
  //       </div>
  //     ),
  //     onClick: (item) => handleViewComment(item),
  //   }, },
  //   { key: "reports_count", label: "Reports" },
  // ];

  
  const stripHtmlTags = (html: string) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    // Get the text content and include newlines for block elements
    let plainText = tempDiv.textContent || tempDiv.innerText || "";

    // Add a newline where there are block elements like <p> or <div>
    plainText = plainText.replace(/<\/?(p|div|br)>/g, "\n").trim();

    return plainText;
  };


  // const strippedContent = stripHtmlTags(folder.post_status || "");
  // const limit = 10; 

  // const clippedContent =
  //   strippedContent.length > limit
  //     ? strippedContent.slice(0, limit) + "..."
  //     : strippedContent;

  const columns: TableColumn[] = [
    {
      key: "profile",
      label: "Profile Pic",
      sortable: false,
      render: (item) => {
        if (item.profile) {
          return <img src={item.profile} alt="Profile" />;
        }
      },
    },
    {
      key: "name",
      label: "User Name",
      sortable: true,
      dataType: "string",
      // search:true
    },
    {
      key: "display_time",
      label: "Posted Time",
      // render: (record) =>
      //   new Date(record.display_time).toLocaleString("en-GB", {
      //     day: "2-digit",
      //     month: "2-digit",
      //     year: "numeric",
      //     hour: "2-digit",
      //     minute: "2-digit",
      //     hour12: true,
      //   }),
      dataType: "string",
      sortable: true,
      // search:true
    },
    {
      key: "post_status",
      label: "Content",
      sortable: false,
      render: (item) => (
        <div
          dangerouslySetInnerHTML={{ __html: item.post_status }}
          title={stripHtmlTags(item.post_status)}
          // className="fixed-container"
          // style={{width: "200px"}}
          style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}

        ></div>
      ),
      dataType: "string",
      // search:true
    },

    {
      key: "assets_count",
      label: "Media",
      // dataType: "button",
      sortable: true,
      // button: {
      //   label: (item) => (
      //     <div style={{ display: "flex", alignItems: "center", fontSize:"14px" }}>
      //       <EyeFill style={{ marginRight: "8px" }} />
      //       {item.assets_count || 0}
      //     </div>
      //   ),
      //   // onClick: handleViewMedia,
      //   onClick: (item) => handleViewMedia(item),
      // },
      render: (item)=>(
        <div 
        style={{ display: "flex",
           alignItems: "center",
           justifyContent: "center",
           gap: "2",
           width: "58px",
           margin: "auto",
           padding: "6px",
           color: "#fff",
           backgroundColor: "rgb(255, 204, 0)",
           cursor: "pointer"
          }}
        onClick={()=> handleViewMedia(item)}
        // className="btn-secondary"
        >
          <EyeFill style={{ marginRight: "8px" }} />
              {item.assets_count || 0}
            </div>
            )
    },
    {
      key: "likes_count",
      label: "Likes",
      // dataType: "button",
      sortable: true,
      // button: {
      //   label: (item) => (
      //     <div style={{ display: "flex", alignItems: "center", fontSize:"14px" }}>
      //       <HandThumbsUp style={{ marginRight: "8px" }} />
      //       {item.likes_count || 0}
      //     </div>
      //   ),
      //   onClick: (item) => handleViewLike(item),
      // },
      render: (item)=>(
        <div 
        style={{ display: "flex",
           alignItems: "center",
           justifyContent: "center",
           gap: "2",
           width: "58px",
           margin: "auto",
           padding: "6px",
           color: "#fff",
           backgroundColor: "rgb(255, 204, 0)",
           cursor: "pointer"
          }}
        onClick={()=> handleViewLike(item)}
        // className="btn-secondary"
        >
           <HandThumbsUp style={{ marginRight: "8px" }} />
              {item.likes_count || 0}
            </div>
            )
    },

    {
      key: "comments",
      label: "Comments",
      // dataType: "button",
      sortable: true,
      // button: {
      //   label: (item) => (
      //     <div style={{ display: "flex", alignItems: "center", fontSize:"14px" }}>
      //       <ChatFill style={{ marginRight: "8px" }} />
      //       {item.comments_count || 0}
      //     </div>
      //   ),
      //   onClick: (item) => handleViewComment(item),
      // },
      render: (item)=>(
        <div 
        style={{ display: "flex",
           alignItems: "center",
           justifyContent: "center",
           gap: "2",
           width: "58px",
           margin: "auto",
           padding: "6px",
           color: "#fff",
           backgroundColor: "rgb(255, 204, 0)",
           cursor: "pointer"
          }}
        onClick={()=> handleViewComment(item)}
        // className="btn-secondary"
        >
          <ChatFill style={{ marginRight: "8px" }} />
            {item.comments_count || 0}
            </div>
            )
    },

    {
      key: "reports_count",
      label: "Reports",
      // dataType: "button",
      sortable: true,
      // button: {
      //   label: (item) => (
      //     <div style={{ display: "flex", alignItems: "center", fontSize:"14px" }}>
      //       <PeopleFill style={{ marginRight: "8px" }} />
      //       {item.reports_count || 0}
      //     </div>
      //   ),
      //   // onClick: handleReportsView,
      //   onClick: (item) => handleReportsView(item),
      // },
      render: (item)=>(
        <div 
        style={{ display: "flex",
           alignItems: "center",
           justifyContent: "center",
           gap: "2",
           width: "58px",
           margin: "auto",
           padding: "6px",
           color: "#fff",
           backgroundColor: "rgb(255, 204, 0)",
           cursor: "pointer"
          }}
        onClick={()=> handleReportsView(item)}
        // className="btn-secondary"
        >
          <PeopleFill style={{ marginRight: "8px" }} />
          {item.reports_count || 0}
            </div>
            )
    },
    { key: "status", label: "Hide / Unhide", dataType: "toggle", sortable: true },
    {
      key: "reportRemarkByAdmin",
      label: "Reason for Hide",
      render: (item) => {
        if (item.reportRemarkByAdmin) {
          return item.reportRemarkByAdmin
        } else {
          return "";
        }
      },
      sortable: true,
      dataType: "string",
      // search:true
    },
    {
      key: "reportRemarkByAdminDate",
      label: "Hide Date",
      sortable: true,
      // render: (record) => {
      //   if(record.reportRemarkByAdminDate){
      //  return new Date(record.reportRemarkByAdminDate).toLocaleString("en-GB", {
      //     day: "2-digit",
      //     month: "2-digit",
      //     year: "numeric",
      //     hour: "2-digit",
      //     minute: "2-digit",
      //     hour12: true,
      //   })
      //   } else{
      //     return ""
      //   }

      // },
      dataType: "string",
    },
  ];

  const redirect = () => {
    navigate("/post/add", { state: { posttype: 0, name: "club" } });
  };

  const addPostGroup = () => {
    navigate("/culturalPost/addPostGroup");
  };

  // const redirect = () => {
  //   navigate("/post/add", { state: { posttype: 1, name: "Wall" } });
  // };

  const handleViewLike = async (item: any) => {
    if (item.likes_count === 0) return;
    if (modalRefLike.current) {
      try {
        const payload = {
          news_feed_id: item.id,
          sortType: "like",
        };
        dispatch(showLoader("Loading data..."));
        const response = await postDetails(APIList.ViewUserList, payload);
        // console.log(response.data);

        if (response.status === "Failed") {
          dispatch(showToast("Unable to fetch likes"));
          setTimeout(() => dispatch(hideToast()), 3000);
          return;
        }

        const sortedLikesData = sortByRecentDate(response.data, "created");
        // console.log("Sorted likes data",sortedLikesData);

        setLikesData(sortedLikesData);
        modalRefLike.current.toggleModalWrapper(true);
      } catch (error) {
        console.error("Error fetching likes:", error);
        dispatch(showToast("Some error occurred while fetching likes"));
        setTimeout(() => dispatch(hideToast()), 3000);
      } finally {
        dispatch(hideLoader());
      }
    }
  };

  const handleViewComment = async (item: any) => {
    if (item.comments_count === 0) return;
    if (modalRefComment.current) {
      try {
        const payload = {
          news_feed_id: item.id,
          sortType: "comment",
        };
        dispatch(showLoader("Loading data..."));
        const response = await postDetails(APIList.ViewUserList, payload);
        console.log(response.data);
        if (response.status === "Failed") {
          dispatch(showToast("Unable to fetch comments"));
          setTimeout(() => dispatch(hideToast()), 3000);
          return;
        }

        const sortedCommentData = sortByRecentDate(response.data, "created");

        setcommentData(sortedCommentData);
        modalRefComment.current.toggleModalWrapper(true);
      } catch (error) {
        console.error("Error fetching comments:", error);
        dispatch(showToast("Some error occurred while fetching comments"));
        setTimeout(() => dispatch(hideToast()), 3000);
      } finally {
        dispatch(hideLoader());
      }
    }
  };

  const handleViewMedia = async (item: any) => {
    if (item.assets_count === 0) return;
    if (modalRefView.current) {
      try {
        const payload = {
          news_feed_id: item.id,
          sortType: "media",
        };
        dispatch(showLoader("Loading data..."));
        const response = await postDetails(APIList.ViewUserList, payload);
        console.log(response.data);
        if (response.status === "Failed") {
          dispatch(showToast("Unable to fetch media"));
          setTimeout(() => dispatch(hideToast()), 3000);
          return;
        }

        setviewListData(response.data || []);

        modalRefView.current.toggleModalWrapper(true);
      } catch (error) {
        console.error("Error fetching media:", error);
        dispatch(showToast("Some error occurred while fetching media"));
        setTimeout(() => dispatch(hideToast()), 3000);
      } finally {
        dispatch(hideLoader());
      }
    }
  };

  // const openMediaIndividual = () => {

  //   console.log("heehehhehehhe")
  //   if (modalRefViewIndividual.current) {
  //     modalRefViewIndividual.current.toggleModalWrapper(true)
  //   }
  // };

  const openMediaIndividual = (item: PostListing) => {
    setSelectedMedia(item);

    if (modalRefViewIndividual.current) {
      modalRefViewIndividual.current.toggleModalWrapper(true);
    }
  };

  const handlePostStatus = (selectedValue: string) => {
    if (selectedValue === "Reported Post") {
      setFeedType(1);
      fetchGetAllFolder(1);
    } else {
      setFeedType(0);
      fetchGetAllFolder(0);
    }
  };

  const handleReportsView = async (item: PostListing) => {
    navigate("/report-user", { state: { item, pageName: "Report" } });
  };

  const handlePost = () => {
    // console.log("new post");
  };

  // const [fromDate, setFromDate] = useState<Date | null>(null);
  // const [toDate, setToDate] = useState<Date | null>(null);

  const handleDownloadVideo = () => {
    setPostType("video");
    setShowDownloadMediaModal(true);
  };
  const handleDownloadImages = () => {
    setPostType("image");
    setShowDownloadMediaModal(true);
  };

  const handleCloseDownloadMediaModal = () => {
    setStartDate(null);
    setEndDate(null);
    setShowDownloadMediaModal(false);
  };
  // const handleFromDateChange = (date: Date | null) => {
  //   setFromDate(date);

  // };

  // const handleToDateChange = (date: Date | null) => {
  //   setToDate(date);

  // };

  // const closeModal = () => {
  //   setPostType("");
  //   if (modalRef.current) {
  //     modalRef.current.toggleModalWrapper(false);
  //   }
  // };

  const handleMediaDownload = async (
    ev: React.FormEvent
    // postType: string = "image"
  ) => {
    ev.preventDefault();
    console.log("Post Type:", postType);
    // Ensure that fromDate and toDate are not null
    let errors = { startDateError: "", endDateError: "" };
    const today = new Date();

    // Validate start date (No validation needed since it can be any date)
    if (!startDate) {
      errors.startDateError = "Please select a start date.";
    }

    // Validate end date
    if (!endDate) {
      errors.endDateError = "Please select an end date.";
    } else if (endDate < startDate!) {
      errors.endDateError = "End date cannot be earlier than the start date.";
    } else if (endDate > today) {
      errors.endDateError = "End date cannot be later than today.";
    }

    setDateErrors(errors);
    if (!errors.startDateError && !errors.endDateError) {
      console.log(startDate, endDate);
      const formattedStartDate = startDate
        ? format(startDate, "dd-MM-yyyy")
        : "";
      const formattedEndDate = endDate ? format(endDate, "dd-MM-yyyy") : "";

      const payload = {
        fromDate: formattedStartDate,
        toDate: formattedEndDate,
      };

      // console.log(payload);

      let response: any;
      try {
        setIsDownloading(true);
        dispatch(showLoader("Downloading Media..."));
        if (postType === "image") {
          response = await fetchMedia(
            APIList.DOWNLOAD_CULTURAL_CLUB_PHOTOS,
            payload
          );
        } else if (postType === "video") {
          response = await fetchMedia(
            APIList.DOWNLOAD_CULTURAL_CLUB_VIDEOS,
            payload
          );
        }

        // if(response.success){
        dispatch(showToast(response.message));
        setTimeout(() => dispatch(hideToast()), 3000);
        // }
        // else{
        //     // alert(response.message)
        //     dispatch(showToast(response.message));
        //     setTimeout(() => dispatch(hideToast()), 3000);
        // }
        //   const blob = new Blob([response], { type: 'application/zip' });
        //         const url = window.URL.createObjectURL(blob);
        //       const link = document.createElement('a');
        //       link.href = url;
        //       link.setAttribute('download', 'file.zip');  // Filename to save as
        //       document.body.appendChild(link);
        //       link.click();
        //       link.remove();
      } catch (error) {
        console.error(error);
        dispatch(showToast("Some error occurred while downloading media"));
        setTimeout(() => dispatch(hideToast()), 3000);
      } finally {
        handleCloseDownloadMediaModal();
        setIsDownloading(false);
        dispatch(hideLoader());
      }
    }
  };

  const toggleHideUnhide = async (item: any) => {
    let userConfirm = null;

    if (item.status === 1) {
      userConfirm = window.prompt("Reason for hide:");
      if (!userConfirm) {
        return;
      }
    }

    try {
      const newToggle = item.status === 1 ? 0 : 1;
      const response = await postDetails(APIList.TOGGLE_HIDE_UNHIDE, {
        id: item.id,
        reportRemarkByAdmin: userConfirm ? userConfirm : "null",
        status: newToggle,
      });

      if (response.Status === "Failed") {
        dispatch(showToast("Cannot update status"));
        setTimeout(() => dispatch(hideToast()), 3000);
        return;
      }

      setFolders((prevData: any) =>
        prevData.map((row: any) =>
          row.id === item.id ? { ...row, status: newToggle } : row
        )
      );

      dispatch(showToast("Status Successfully Updated."));
      setTimeout(() => dispatch(hideToast()), 3000);
      fetchGetAllFolder(undefined, undefined, debouncedSearchQuery);
    } catch (error) {
      console.error("Error updating status:", error);
      dispatch(showToast("Some error occurred while updating status"));
      setTimeout(() => dispatch(hideToast()), 3000);
    }
  };

  const deletePost = async (item: any) => {
    // console.log(item)
    try {
      const response = await postDetails(APIList.DELETE_POST, { id: item.id });
      if (response.status === "Failed") {
        dispatch(showToast("Cannot delete post"));
        setTimeout(() => dispatch(hideToast()), 3000);
        return;
      }

      dispatch(showToast("Post Deleted Succesfully."));
      setTimeout(() => dispatch(hideToast()), 3000);
      fetchGetAllFolder();
    } catch (error) {
      console.error("Error deleting post:", error);
      dispatch(showToast("Some error occurred while deleting post"));
      setTimeout(() => dispatch(hideToast()), 3000);
    }
  };

  const handleBulkDelete = async () => {
    try {
      const ids = Array.from(selectedItems);
      console.log(ids);
      const response = await postDetails(APIList.DELETE_POST, { id: ids });
      console.log(response);

      if (response.status === "Failed") {
        dispatch(showToast("Cannot delete posts"));
        setTimeout(() => dispatch(hideToast()), 3000);
        return;
      }

      dispatch(showToast("Posts deleted successfully."));
      setTimeout(() => dispatch(hideToast()), 3000);
      setSelectedItems(new Set());
      fetchGetAllFolder();
    } catch (error) {
      console.error("Error deleting posts:", error);
      dispatch(showToast("Some error occurred while deleting posts"));
      setTimeout(() => dispatch(hideToast()), 3000);
    } finally {
      setShowDeleteModal(false);
    }
  };

  const buttons = [
    {
      label: "Please Select",
      theme: "danger",
      onClick: handlePost,
      dropdown: [
        { label: "All Post", onClick: handlePost, onSelect: handlePostStatus },
        {
          label: "Reported Post",
          onClick: handlePost,
          onSelect: handlePostStatus,
        },
      ],
    },
    {
      label: "Delete",
      theme: "danger",
      icon: <TrashFill />,
      onClick: () => setShowDeleteModal(true),
      disabled: selectedItems.size === 0,
    },
    {
      label: "Download Video",
      theme: "danger",
      icon: <Download />,
      onClick: handleDownloadVideo,
    },
    {
      label: "Download Images",
      theme: "danger",
      icon: <Download />,
      onClick: handleDownloadImages,
    },
    {
      label: "Assign Group",
      theme: "warning",
      icon: <PeopleFill />,
      onClick: addPostGroup,
    },
    {
      label: "Add Post",
      theme: "warning",
      icon: <PlusCircleFill />,
      onClick: redirect,
    },
  ];

  const handleCheckboxChange = (selectedIds: Set<number>) => {
    // console.log(selectedIds);
    setSelectedItems(selectedIds);
  };

  return (
    <LayoutContainer title="Cultural Club">
      <Modal show={showDeleteModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-4">Are you sure you want to delete?</p>
          <div className="d-flex flex-column-reverse flex-md-row align-items-md-center justify-content-md-center gap-3 mb-2">
            <CustomButton theme="yellow" size="md" onClick={handleBulkDelete}>
              Delete
            </CustomButton>
            <CustomButton theme="red" size="md" onClick={handleCloseModal}>
              Cancel
            </CustomButton>
          </div>
        </Modal.Body>
      </Modal>
      <div className=" page-header d-flex align-items-center justify-content-left dashboard-container h-100">
        <h2>
          <i className="page-header-icon fa fa fa-home"></i>
          Cultural Post Data
        </h2>
      </div>
      <PageHeader buttons={buttons} />

      <Modal
        show={showDownloadMediaModal}
        onHide={handleCloseDownloadMediaModal}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Date Range</Modal.Title>
        </Modal.Header>
        <Modal.Body
        // style={{overflowY:"visible"}}
        >
          <form
            onSubmit={(ev) => {
              handleMediaDownload(ev);
            }}
          >
            <div
              className="d-flex justify-content-between gap-4 font-12"
              style={{ marginBottom: "60px" }}
            >
              <div className="height-50px">
                <label>
                  Start Date: <span className="text-danger">*</span>
                </label>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  selectsStart
                  startDate={startDate}
                  maxDate={new Date()}
                  endDate={endDate}
                  onKeyDown={(e: any) => {
                    e.preventDefault();
                  }}
                  required
                  dateFormat="dd-MM-yyyy"
                  placeholderText="Select start date"
                  className={`mf-admin-inputfield`}
                  showMonthDropdown // Add month dropdown
                  showYearDropdown // Add year dropdown
                  dropdownMode="select"
                />
                {dateErrors.startDateError && (
                  <div className="error-text">{dateErrors.startDateError}</div>
                )}
              </div>

              <div className="height-50px">
                <label>
                  End Date: <span className="text-danger">*</span>
                </label>
                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  minDate={startDate}
                  maxDate={new Date()}
                  onKeyDown={(e: any) => {
                    e.preventDefault();
                  }}
                  required
                  dateFormat="dd-MM-yyyy"
                  placeholderText="Select end date"
                  className={`mf-admin-inputfield`}
                  showMonthDropdown // Add month dropdown
                  showYearDropdown // Add year dropdown
                  dropdownMode="select"
                />
                {dateErrors.endDateError && (
                  <div className="error-text">{dateErrors.endDateError}</div>
                )}
              </div>
            </div>

            <div>
              <CustomButton
                theme="yellow"
                type="submit"
                size="md"
                disabled={isDownloading}
              >
                Download
              </CustomButton>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      {/* <ModalWrapper ref={modalRefVid} title="Select Date Range">
        <form
          onSubmit={(ev) => {
            handleDateSubmit(ev, postType);
          }}
        >
          <CustomDatePicker
            dateFormat="dd-MMM-yyyy"
            minDate={new Date("2023-01-01")}
            maxDate={new Date()}
            placeholderText="Select From date"
            label="Select From Date"
            onChange={handleFromDateChange}
            defaultDate={fromDate}
            required={true}
            monthPicker={false}
            showLabel={true}
            className="custom-datepicker-class"
            name="from-date-picker"
          />

          {fromDate && (
            <div>
              <p>Selected From Date: {fromDate.toDateString()}</p>
            </div>
          )}

          <CustomDatePicker
            dateFormat="dd-MMM-yyyy"
            minDate={new Date("2023-01-01")}
            maxDate={new Date()}
            placeholderText="Select To Date"
            label="Select To Date"
            onChange={handleToDateChange}
            defaultDate={toDate}
            required={true}
            monthPicker={false}
            showLabel={true}
            className="custom-datepicker-class"
            name="to-date-picker"
          />

          {toDate && (
            <div>
              <p>Selected To Date: {toDate.toDateString()}</p>
            </div>
          )}

          <div>
            <CustomButton theme="yellow" type="submit" size="md">
              Download
            </CustomButton>
          </div>
        </form>
      </ModalWrapper> */}

      {/* <ModalWrapper ref={modalRefViewIndividual} title="View">
        <div
          className="d-flex flex-wrap justify-content-center"
          style={{
            maxHeight: "700px",
            maxWidth: "500px",
            overflowY: "auto",
            padding: "10px",
          }}
        >
          {selectedMedia ? (
            <div className="media-item d-flex flex-column align-items-center">
              {selectedMedia.media_type === "pdf" ? (
                <iframe
                  src={selectedMedia.media_file}
                  style={{ width: '100%', height: '500px', border: 'none' }}
                  title="PDF Viewer"
                />
              ) : selectedMedia.media_type === "Video" ? (
                <video
                  src={selectedMedia.media_file}
                  controls
                  style={{
                    width: "400px",
                    height: "400px",
                  }}
                />
              ) : selectedMedia.media_type === "Image" ? (
                <img
                  src={selectedMedia.media_file}
                  alt="Media File"
                  style={{
                    width: "400px",
                    height: "400px",
                  }}
                />
              ) : (
                <p>Unsupported media type</p>
              )}
            </div>
          ) : (
            <p>No media to display.</p>
          )}
        </div>
      </ModalWrapper> */}
      <ModalWrapper ref={modalRefViewIndividual} title="View">
        <div
          className="d-flex flex-wrap justify-content-center"
          style={{
            height: "500px", // Increase max height
            maxWidth: "80vw", 
            overflowY: "auto",
            // padding: "10px",
          }}
        >
          {selectedMedia ? (
            <div className="media-item d-flex flex-column align-items-center w-100"
            style={{ 
              height: selectedMedia.media_type === "pdf" ? "80vh": "400px", 
              width: "100%", 
              overflow: "hidden" }}
            >
              {selectedMedia.media_type === "pdf" ? (
                <iframe
                  src={`${selectedMedia.media_file}#zoom=50`}
                  style={{
                    width: "100%",
                    height: "80vh", // Increase PDF viewer height
                    border: "none",
                  }}
                  title="PDF Viewer"
                />
              ) : selectedMedia.media_type === "Video" ? (
                <video
                  src={selectedMedia.media_file}
                  controls
                  style={{ 
                    width: "100%", 
                    height: "100%",
                    objectFit: "contain",
                    outline: "none", 
                  }}
                />
              ) : selectedMedia.media_type === "Image" ? (
                <img
                  src={selectedMedia.media_file}
                  alt="Media File"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain", // Maintain aspect ratio and fit inside the div
                  }}
                />
              ) : (
                <p>Unsupported media type</p>
              )}
            </div>
          ) : (
            <p>No media to display.</p>
          )}
        </div>
      </ModalWrapper>

      <ModalWrapper ref={modalRefView} title="View Media">
        <div
          className="d-flex flex-wrap justify-content-center"
          style={{
            maxHeight: "420px",
            overflowY: "auto",
            // padding: "10px",
          }}
        >
          {viewListData && viewListData.length > 0 ? (
            viewListData.map((viewList) => (
              <div
                key={viewList.id}
                className="media-item m-2 d-flex flex-column align-items-center"
                // style={{
                //   width: "calc(50% - 20px)",
                // }}
              >
                <div className="d-flex align-items-center justify-content-center">
                  {viewList.media_type === "pdf" ? (
                    <FileEarmarkPdf
                      style={{ width: "200px", height: "200px" }}
                    />
                  ) : viewList.media_type === "Video" ? (
                    <img
                      src={viewList.thumb_image || "default-thumb-url"}
                      alt="Video Thumbnail"
                      style={{
                        width: "200px",
                        height: "200px",
                      }}
                    />
                  ) : viewList.media_type === "Image" ? (
                    <img
                      src={viewList.media_file}
                      alt="Media File"
                      style={{
                        width: "200px",
                        height: "200px",
                      }}
                    />
                  ) : (
                    <p>Unsupported media type</p>
                  )}
                </div>
                <Button
                  variant="outline-secondary"
                  className="mt-2 px-3 btn-warning"
                  onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                    openMediaIndividual(viewList)
                    e.currentTarget.blur()
                    }
                  }
                >
                  <small>View</small>
                </Button>
              </div>
            ))
          ) : (
            <p>No media to display.</p>
          )}
        </div>
      </ModalWrapper>

      <ModalWrapper ref={modalRefLike} title="Likes">
        <div
          style={{
            maxHeight: "500px",
            overflowY: "auto",
            // padding: "10px",
          }}
        >
          {likesData.length === 0 ? (
            <p className="text-center" style={{ fontSize: 18 }}>
              No likes available.
            </p>
          ) : (
            likesData.map((like: any) => (
              <div
                key={like.id}
                className="d-flex mb-4 justify-content-between align-items-center"
              >
                <div className="d-flex align-items-center">
                  <img
                    src={
                      like.userInfo.profile
                        ? like.userInfo.profile
                        : defaultProfile
                    }
                    alt="Profile Picture"
                    className="mx-4"
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      marginRight: "10px",
                    }}
                  />
                  <div className="">
                    <p
                      className="text-start px-2 mb-1"
                      style={{ fontWeight: "700", fontSize: 16 }}
                    >
                      {like.userInfo.name || "User Name Not Available"}
                    </p>
                    <p
                      className="text-start px-2 mb-1"
                      style={{ fontSize: 15 }}
                    >
                      {like.created
                        ? new Date(like.created).toLocaleString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })
                        : "Date Not Available"}
                    </p>
                  </div>
                </div>
                {/* <Button variant="outline-secondary">
        <Trash3Fill />
      </Button> */}
              </div>
            ))
          )}
        </div>
      </ModalWrapper>

      <ModalWrapper ref={modalRefComment} title="Comments">
        <div
          style={{
            maxHeight: "500px",
            overflowY: "auto",
            padding: "0 10px",
          }}
        >
          {CommentData.length === 0 ? (
            <p className="text-center" style={{ fontSize: 14 }}>
              No comments available.
            </p>
          ) : (
            CommentData.map((Comment: any) => (
              <div
                key={Comment.id}
                className="d-flex mb-4 justify-content-between align-items-center"
              >
                <div className="d-flex align-items-center">
                  <div className="avatar-container">
                    <img
                      src={
                        Comment.userInfo.profile
                          ? Comment.userInfo.profile
                          : defaultProfile
                      }
                      alt="Profile Picture"
                      className="avatar"
                    />
                  </div>
                  <div className="">
                    <p
                      className="text-start px-2 mb-1"
                      style={{ fontWeight: "700", fontSize: 16 }}
                    >
                      {Comment.userInfo.name || "User Name Not Available"}
                    </p>
                    <p
                      className="text-start px-2 mb-1"
                      style={{ fontSize: 14 }}
                    >
                      {Comment.comment}
                    </p>
                    <p
                      className="text-start px-2 mb-1"
                      style={{ fontSize: 12 }}
                    >
                      {Comment.created
                        ? new Date(Comment.created).toLocaleString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })
                        : "Date Not Available"}
                    </p>
                  </div>
                </div>
                {/* <Button variant="outline-secondary">
        <Trash3Fill />
      </Button> */}
              </div>
            ))
          )}
        </div>
      </ModalWrapper>
      
      {/* <div className="d-flex justify-content-end mx-4 mt-4">
      <InputGroup style={{ width: "340px" }} className="mb-3">
        <Form.Control
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearchChange}
        />
      </InputGroup>
      </div> */}
      <div>
      <CommonTable<PostListing>
        data={folder}
        columns={columns}
        // onView={(item: any) => console.log("View:", item)}
        // onEdit={(item: any) => console.log("Edit:", item)}
        onDelete={deletePost}
        // onStatusToggle={(item: any) => console.log("Status Toggle:", item)}
        onToggle={toggleHideUnhide}
        pagination={true}
        rowsPerPage={10}
        actions={{
          view: false,
          edit: false,
          delete: true,
          checkbox: true,
          status: false,
        }}
        onPageChange={handlePageChange}
        onCheckboxChange={handleCheckboxChange}
        apiPagination={true}
        totalPageCount={totalRecords}
        apiSearch={true}
        onSearch={handleSearch}
      />
</div>
      {/* <SampleTable /> */}
    </LayoutContainer>
  );
};

export default Post_Listing;
